








import { Component, Prop, Vue } from 'vue-property-decorator';
import UserIcon from '@/components/global/UserIcon.vue';
import UserName from '@/components/global/UserName.vue';
import { store } from '@/utils/store';
import { theme } from '@/utils/constants';

@Component({
  components: {
    UserIcon,
    UserName,
  },
})
export default class Message extends Vue {
  @Prop({ required: true }) message!: ChatMessage;

  get isSelfMessage() {
    return store.githubId === this.message.from;
  }

  get additionalStyle() {
    return !this.isSelfMessage
      ? undefined
      : {
        gridTemplateColumns: 'minmax(0, 1fr)',
        gridTemplateAreas: `
          'message'
        `,
        justifyItems: 'end',
      };
  }

  get additionalStyleForMessage() {
    return !this.isSelfMessage
      ? undefined
      : {
        backgroundColor: theme.main,
        borderRadius: '0.5em 0 0.5em 0.5em',
      };
  }
}
